(function () {
    var multiSearch = {
        init: function () {
            multiSearch.controls();
        },
        controls: function () {
            var $body = $('body');
            $body.on('click', '.teaser__item__zoom-icon', function () {
                $(this).siblings('.figure__image').click();
            });
        },
    };
    UX.multiSearch = multiSearch;
    if ($('.multi-search').length || $('.pb-list').length) {
        UX.multiSearch.init();
    }
})();
